import type { SavedList } from '../wishlistAccount'
import { tItem } from 'src/shared/frontendTypes/wunschliste'
import { tProductPreview } from 'src/shared/frontendTypes/product'

import clone from 'src/functions/cloner'

type items = { [column: string]: tItem }
const items: items = {}

const products: tProductPreview[] = []

const initialState = {

  lists: [] as SavedList[],
  activeList: 'default',
  account: false,
  accountLoading: false,
  accountError: '',
  // Daten der Wunschliste
  timestamp: <string|false>false,
  items,

  // Aktuelle Produkt-Daten
  products,

}

export type tWunschliste = typeof initialState

/* +++++++++++++++++++++++++++++++++++++++++++++++++ */

export type action =
  | { type: 'wishlistAccountLoading' | 'wishlistAccountReset'; payload?: undefined }
  | { type: 'wishlistAccountError'; payload: string }
  | { type: 'wishlistSelect'; payload: string }
  | { type: 'wishlistCommand'; payload: Record<string, unknown> }
  | { type: 'wishlistAccountLoaded'; payload: { lists: SavedList[]; activeList: string } }
  | {
      type: 'restoreWunschlisteItems'
      payload: items
    }
  | {
      type: 'addWunschlisteItem'
      payload: tItem
    }
  | {
      type: 'removeWunschlisteItem'
      payload: string
    }
  | {
      type: 'updateWunschlisteProducts'
      payload: tProductPreview[]
    } 

/* +++++++++++++++++++++++++++++++++++++++++++++++++ */

const save = (state: tWunschliste) => {
  setTimeout(()=>{
    localStorage.setItem('wunschliste', JSON.stringify(state))
  }, 0)
  return { ...state, timestamp: new Date().toISOString() }
}

const reducer = (state = initialState, {type,payload}: action): tWunschliste => {
  switch (type) {
    case 'wishlistAccountLoading': return { ...state, account: true, accountLoading: true, accountError: '', items: {}, products: [] }
    case 'wishlistAccountReset': return { ...initialState }
    case 'wishlistAccountError': return { ...state, accountLoading: false, accountError: payload }
    case 'wishlistAccountLoaded': {
      const list = payload.lists.find(list => list.id === payload.activeList)
      return { ...state, ...payload, account: true, accountLoading: false, accountError: '', items: Object.fromEntries((list?.items || []).map(item => [item.key, item])), products: [] }
    }
    case 'wishlistSelect': {
      const list = state.lists.find(list => list.id === payload)
      return list ? { ...state, activeList: payload, items: Object.fromEntries(list.items.map(item => [item.key, item])), products: [] } : state
    }


    /* -------------------------------------------------------------- */
    /*                     Daten der Wunschliste                      */
    /* -------------------------------------------------------------- */

    case 'restoreWunschlisteItems': {
      return save({ ...state,
        items: payload,
        timestamp: new Date().toISOString(),
      })
    }

    /* -------------------------------------------------------------- */

    case 'addWunschlisteItem': {
      const items = clone(state.items)
      const item = payload
      const { id, key } = item

      items[key] = { id, key }

      return save({ ...state,
        items,
      })
    }

    /* -------------------------------------------------------------- */

    case 'removeWunschlisteItem': {
      const items = clone(state.items)
      delete items[payload]
      return save({ ...state,
        items,
      })
    }

    /* -------------------------------------------------------------- */
    /*                    Aktuelle Produkt-Daten                      */
    /* -------------------------------------------------------------- */

    case 'updateWunschlisteProducts':
      return { ...state,
        products: payload || [],
      }

    /* -------------------------------------------------------------- */

    default: return state

    /* -------------------------------------------------------------- */
    
  }
}

export default reducer